import React, { useState } from 'react';
import * as S from './Header.styles';

const Header = () => {

  return (
    <S.HeaderWrap>
        &nbsp;
    </S.HeaderWrap>
  );
};

export default Header;
